import { AppConfiguration } from '../';

export interface ApplicationService {
  configure: (configuration: AppConfiguration) => void;
  getName: () => symbol
}
